module.exports = __webpack_public_path__ + "img/member_idcard_image3.c3439cab.png";